module.exports = __webpack_public_path__ + "img/edit-pencil.ab05fd35.svg";